// extracted by mini-css-extract-plugin
export default {"node":"TranslationNodeImage_node__g26qn","image":"TranslationNodeImage_image__SmhHg","alt":"TranslationNodeImage_alt__9Dx7p"};